import { useTranslation } from 'react-i18next';
import { useAudio } from 'src/hook/global/useAudio';
import { Challenge } from 'src/model/Challenge';
import { ChallengeTypes } from 'src/model/enum/dataEnums';
import { AnswerType } from 'src/model/enum/enums';
import { GetSoundUrl } from 'src/utils/URLUtils';
import styles from './NotSure.module.scss';

interface NotSureProps {
    onAnswer: (isCorrect: boolean) => void;
    showFinish: boolean;
    currentChallenge?: Challenge;
}

const NotSure = ({ onAnswer, showFinish, currentChallenge }: NotSureProps) => {
    const { t } = useTranslation();
    const { playAudio } = useAudio();

    const handleNotSure = () => {
        playAudio(GetSoundUrl(AnswerType.IncorrectAnswer));
        setTimeout(() => {
            onAnswer(false);
        }, 200);
    };

    const shouldShow = !showFinish && currentChallenge?.Nature !== ChallengeTypes.GivenExampleConfirmRemembering;

    if (!shouldShow) return null;

    return (
        <div className={styles.notSure} onClick={handleNotSure}>
            {t('Not Sure?')}
        </div>
    );
};

export default NotSure; 